import {
  Component,
  ContentChildren,
  Input,
  OnInit,
  QueryList,

  SimpleChanges, TemplateRef
} from "@angular/core";
import { IOutputData } from "angular-split";
import { IcmsSplitArea, IcmsSplitPreset } from "./icms-split.types";

@Component({
  selector: "icms-split",
  templateUrl: "./icms-split.component.html",
  styleUrls: ["./icms-split.component.scss"],
})
export class IcmsSplitComponent implements OnInit {
  @Input() areas: IcmsSplitArea[] = [{ size: 60 }, { size: 40 }];
  @Input() direction: "horizontal" | "vertical" = "horizontal";
  @Input() showLock: boolean = true; // ngIf on the lock icon that allows to lock the gutter.
  @Input() showButtons: boolean = true;
  @Input() disable: boolean = false;
  @ContentChildren(TemplateRef) templates!: QueryList<TemplateRef<any>>;

  @Input() preset?: IcmsSplitPreset;

  public isLocked: boolean = false;

  ngOnInit() {
    this.isLocked = this.disable;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.preset) {
      const previousValue = changes.preset.previousValue;
      if(previousValue && previousValue != this.preset)
        this.applyPresetSizes(this.preset);
    }
  }

  toggleLock() {
    this.isLocked = !this.isLocked;
  }

  collapseArea(index: number, areaToCollapseDirection: "before" | "after", max: boolean = false) {
    const areaIndexToChange =
      index === 0 || areaToCollapseDirection === "before"
        ? index + 1
        : index - 1;
    const sizeBeforeExpand = this.areas[areaIndexToChange].size;
    this.areas[areaIndexToChange].size = this.getAreaToExpandNewSize(
      this.areas[areaIndexToChange],
      this.areas[index],
      max
    );
    this.areas[index].size =
      this.areas[index].size +
      sizeBeforeExpand -
      this.areas[areaIndexToChange].size;
  }

  getAreaToExpandNewSize(
    areaToExpand: IcmsSplitArea,
    areaToCollapse: IcmsSplitArea,
    max: boolean = false
  ): number {
    const totalAvailableAreaSize = areaToExpand.size + areaToCollapse.size;
    var minOrMax = max ? Math.max : Math.min;
    var areaToExpandNewSize = minOrMax(
      areaToExpand.middleSize && areaToExpand.size < areaToExpand.middleSize
        ? areaToExpand.middleSize
        : areaToExpand.maxSize ?? 100,
      totalAvailableAreaSize - (areaToCollapse.minSize ?? 0)
    );
    return areaToExpandNewSize;
  }

  dragEnd(e: IOutputData) {
    this.areas = this.areas.map((area, index) => {
      area.size = e.sizes[index] as number;
      return area;
    });
  }

  applyPresetSizes(preset: IcmsSplitPreset) {
    if (preset == "middleSize") {
      this.setMiddleSizePreset(this.areas.length);
    }
    else{
      this.setMinSizePreset(this.areas.length);
    }
  }
  setMinSizePreset(arrayLength: number) {
    for (let i = arrayLength - 1; i > 0; i--) {
      if (this.direction == "horizontal") {
        this.collapseMaxArea(i, "after");
      } else {
        this.collapseMaxArea(i - 1, "before");
      }
    }
  }
  
  setMiddleSizePreset(arrayLength: number) {
    for (let i = arrayLength - 1; i > 0; i--) {
      if (this.direction == "horizontal") {
        this.collapseMiddleAreaHorizontal(i);
      } else {
        this.collapseMiddleArea(i - 1, "before");
      }
    }
  }

  collapseMaxArea(index: number, areaToCollapseDirection: "before" | "after") {
    const areaIndexToChange =
      index === 0 || areaToCollapseDirection === "before"
        ? index + 1
        : index - 1;
    const sizeBeforeExpand = this.areas[areaIndexToChange].size;
    this.areas[areaIndexToChange].size = this.areas[areaIndexToChange].size + this.areas[index].size;
    this.areas[index].size =
      this.areas[index].size +
      sizeBeforeExpand -
      this.areas[areaIndexToChange].size;
  }

  collapseMiddleArea(index: number, areaToCollapseDirection: "before" | "after") {
    const areaIndexToChange =
      index === 0 || areaToCollapseDirection === "before"
        ? index + 1
        : index - 1;
    const sizeBeforeExpand = this.areas[areaIndexToChange].size;
    this.areas[areaIndexToChange].size = this.areas[areaIndexToChange].middleSize;
    this.areas[index].size =
      this.areas[index].size +
      sizeBeforeExpand -
      this.areas[areaIndexToChange].size;
  }
  
  collapseMiddleAreaHorizontal(index: number) {
    const leftIndex = index - 1;
    const leftSizeBeforeExpand = this.areas[leftIndex].size;
    const rightSizeBeforeExpand = this.areas[index].size;
    this.areas[index].size = this.areas[index].middleSize;
    this.areas[leftIndex].size = rightSizeBeforeExpand + leftSizeBeforeExpand - this.areas[index].size;
  }
}
